
































import { computed, defineComponent, PropType, ref } from "@vue/composition-api";
import { TagInfo, TagInfoType } from "@scrile/api-provider/dist/api/TagsProvider";
import { UserLocation } from "@scrile/api-provider/dist/api/UserPublicDataProvider";
import useTags from "@/hooks/useTags";
import { $t } from "@/lib/i18nHelpers";
import config from "@/config";
import BaseButton from "@/components/BaseButton";
import FilterCreatorLanguageInput from "@/components/FilterCreatorLanguageInput";
import FilterCreatorLocationInput from "@/components/FilterCreatorLocationInput";
import ModalView from "@/components/ModalView";
import TagsController from "@/components/TagsController";

export default defineComponent({
  name: "FiltersCreatorModal",
  components: {
    BaseButton,
    TagsController,
    ModalView,
    FilterCreatorLocationInput,
    FilterCreatorLanguageInput,
  },
  props: {
    value: { type: Boolean, required: true },
    selectedTags: { type: Array as () => TagInfo[], required: true },
    tagsType: { type: String as () => TagInfoType, required: true },
    title: { type: String, default: $t("Categories") },
    languages: { type: Array as PropType<string[]>, default: [] },
    locations: { type: Array as PropType<UserLocation[]>, default: [] },
  },
  setup(props, { emit }) {
    const { getTags, tags } = useTags();
    const clearCb = ref<Function>(() => {});
    const selectedTagsIds = ref<string[]>([]);
    const selectedLanguages = ref<string[]>([]);
    const selectedLocations = ref<UserLocation[]>([]);
    const showLocalization = computed(() => !config.featureHideLocalization);
    const isSelectedFilter = computed(() => props.selectedTags.length > 0);

    const setClearCb = (cb: Function) => {
      clearCb.value = cb;
    };

    const clear = () => {
      clearCb.value();
      selectedTagsIds.value = [];
    };
    const selectTags = (tags: TagInfo[]) => {
      selectedTagsIds.value = tags.map(i => i.id);
    };

    const selectLanguages = (languages: string[]) => {
      selectedLanguages.value = languages;
    };

    const selectLocations = (locations: UserLocation[]) => {
      selectedLocations.value = locations;
    };

    const save = () => {
      const selectedTags = tags.value.filter(tag => selectedTagsIds.value?.includes(tag.id));
      emit("select", selectedTags);
      emit("selectLanguages", selectedLanguages.value);
      emit("selectLocations", selectedLocations.value);
    };

    getTags(props.tagsType);

    return {
      showLocalization,
      isSelectedFilter,
      setClearCb,
      save,
      selectTags,
      selectLanguages,
      selectLocations,
      clear,
    };
  },
});
